<div id="getNetworkServersOfNSGroup" class="table-header margin-top-30">
  <span>Group Network Servers</span>
  <div class="table-filter">
    <form class="form-inline ">
      <select id="table-network-search"
              class="table-filter-search form-control"
              [(ngModel)]="optionGroupNetworkServerSearch"
              name="optionGroupNetworkServerSearch"
              (change)='onOptionGroupNetworkServerSearchChanged($event)'>
        <option selected="selected">Search Type</option>
        <option>NS ID</option>
        <option>Name</option>
      </select>
      <input type="text"
             class="form-control"
             id="input-network-search"
             name="inputKeywordGroupNetworkServerSearch"
             [(ngModel)]="inputKeywordGroupNetworkServerSearch"
             aria-describedby="search"
             placeholder="Search"
             (keyup)="onKeywordSearch($event)">
      <i class="fa fa-search text-tooltip"
         aria-hidden="true" title-popup="Search" (click)="refreshGroupNetworkServers()">
      </i>
    </form>
  </div>
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip"
       aria-hidden="true"
       title-popup="List">
    </i>
    <div class="tooltip-actions width-140">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0"
                 table-name="group-network-servers-list"
                 class="checked">Net ID
          </label>
        </li>
        <li>
          <label col-id="1"
                 table-name="group-network-servers-list"
                 class="checked">Name
          </label>
        </li>
      </ul>
    </div>
  </div>
  <div class="table-icon refresh"
       (click)="refreshGroupNetworkServers()">
    <i class="text-tooltip"
       [ngClass]="(groupServersRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
       aria-hidden="true"
       title-popup="Refresh">
    </i>
  </div>
</div>
<table class="table table-striped"
       id="group-network-servers-list">
  <thead>
  <tr>
    <th>Net ID(s)</th>
    <th>NS ID</th>
    <th>Name</th>
    <th>DevAddr Pool</th>
    <th>Subnetwork ID</th>
    <th *ngIf="isAdmin"></th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let item of listGroupNetworkServers | paginate: configPagerGroupNetworkServers">
    <td class="serverNetworkServers-netId-td"><a [routerLink]="['/network',item.virtId]">{{item.netIds | cidr}}</a></td>
    <td class="serverNetworkServers-netId-td"><a [routerLink]="['/network',item.virtId]">{{item.nsId}}</a></td>
    <td><a [routerLink]="['/network',item.virtId]">{{item.name}}</a></td>
    <td>{{item.devAddrRange}}</td>
    <td>{{item.subnwkId}}</td>
    <td *ngIf="isAdmin">
      <ng-template #actionsPopup>
        <p class="popup-text" (click)="deleteModal.show()">Delete</p>
      </ng-template>
      <button class="view-detail-btn"
              [popover]="actionsPopup"
              placement="left"
              triggers="click"
              [outsideClick]="true"
              container="body">...</button>
        <app-delete-modal #deleteModal
                          text="Network server {{item['name']}} will be deleted."
                          server="{{item['virtId']}}"
                          deleteType="networkServerDetail"></app-delete-modal>
    </td>
  </tr>
  </tbody>
</table>
<div class="noDataRow"
     *ngIf="!listGroupNetworkServers || listGroupNetworkServers.length === 0">There is no data available
</div>
<app-pagination-custom [config]="configPagerGroupNetworkServers"
                       (click)="refreshGroupNetworkServers()"></app-pagination-custom>
